import { getStore } from '../store/store';
import { CalendarEventsFilters } from '../utils/CalendarEventsFilters';

export function getCurrentFilters(): (CalendarEventsFilters | string)[] {
    return getStore().currentFilters;
}
